import { patch } from 'services/billing'
import { checkRoles } from 'utils'
import { Role } from 'models'

export async function finalize(invoiceId: number): Promise<void> {
  await checkRoles([Role.ROOT, Role.MANAGER, Role.FINANCE])
  await patch(`/invoices/${invoiceId}/finalize`)
}
